import {CartCreateHintItem, CartCreateHintItemStock} from "../../../../models/cart/create/cart.create";

export const getHintItemStocks = (item: CartCreateHintItem): CartCreateHintItemStock[] => {
    const stocks = Array.isArray(item.stock) ? item.stock : item.stocks;
    if (!Array.isArray(stocks)) return [];
    return stocks.filter(stock => stock && typeof stock.warehouse === "string"
        && Number.isFinite(stock.requiredQty) && stock.requiredQty > 0
        && Number.isFinite(stock.availableQty) && stock.availableQty >= 0
        && Number.isFinite(stock.replacementQtyFactor) && stock.replacementQtyFactor > 0);
};

export const getVisibleHintStocks = (
    stocks: CartCreateHintItemStock[] | undefined | null,
    usedWarehouses: string[]
): CartCreateHintItemStock[] => (stocks || []).filter(stock => usedWarehouses.includes(stock.warehouse));

export const getHintCoverage = (stocks: CartCreateHintItemStock[], usedWarehouses: string[], useBackorder = false) => {
    const visibleStocks = getVisibleHintStocks(stocks, usedWarehouses);
    // The API omits zero-stock warehouses, but replacement quantities are warehouse-independent.
    const replacementStock = visibleStocks[0] || stocks[0];
    const requiredQty = replacementStock?.requiredQty || 0;
    const availableQty = visibleStocks.reduce((total, stock) => total + stock.availableQty, 0);
    return {
        requiredQty,
        availableQty,
        replacementQtyFactor: replacementStock?.replacementQtyFactor,
        type: replacementStock?.type,
        hasStock: useBackorder || Boolean(replacementStock),
        isFullyReplaceable: visibleStocks.some(stock => stock.fullyQtyReplaceable) && availableQty >= requiredQty,
        qtyToAdd: useBackorder ? requiredQty : Math.min(requiredQty, availableQty),
    };
};

export const getHintKey = (item: CartCreateHintItem): string => JSON.stringify([item.requestedNo, item.article.id]);
export const formatHintQty = (value: number): string => value.toLocaleString();

export const createHintRow = (item: CartCreateHintItem, usedWarehouses: string[], useBackorder = false) => {
    const stocks = getHintItemStocks(item);
    return {
        key: getHintKey(item),
        item,
        stocks: getVisibleHintStocks(stocks, usedWarehouses),
        coverage: getHintCoverage(stocks, usedWarehouses, useBackorder),
    };
};

export type CartHintRow = ReturnType<typeof createHintRow>;
